
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";








import { useGetTimberTypeQuery, useGetTimberTypeListQuery, useGetTimberTypePresentationQuery } from "../../../../timber/apis/TimberType.api";
import { TimberTypeNameDisplay, default as TimberTypeName } from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import { toString as toStringTimberType, PrimaryTimberType } from "../../../../timber/types/models/TimberType";

import { useGetTimberClassQuery, useGetTimberClassListQuery, useGetTimberClassPresentationQuery } from "../../../../timber/apis/TimberClass.api";
import { TimberClassNameDisplay, default as TimberClassName } from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import { toString as toStringTimberClass, PrimaryTimberClass } from "../../../../timber/types/models/TimberClass";

import { useGetThicknessClassQuery, useGetThicknessClassListQuery, useGetThicknessClassPresentationQuery } from "../../../../timber/apis/ThicknessClass.api";
import { ThicknessClassNameDisplay, default as ThicknessClassName } from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import { toString as toStringThicknessClass, PrimaryThicknessClass } from "../../../../timber/types/models/ThicknessClass";

import { useGetShipmentQuery, useGetShipmentListQuery, useGetShipmentPresentationQuery } from "../../../../timber/apis/Shipment.api";
import { ShipmentNameDisplay, default as ShipmentName } from "../../../../timber/components/shipment/ShipmentDetail/ShipmentName";
import { toString as toStringShipment, PrimaryShipment } from "../../../../timber/types/models/Shipment";

import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import ManageSearch from "@mui/icons-material/ManageSearch";
import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";




export const initialFormStateFn = () => { return {
    
    
    
    
    
    
        timberTypeId: [],
        
    
        classId: [],
        
    
        thicknessClassId: [],
        
    
    
    
} }

export const formObject = {
    
        internalKey: string()
        .trim()
        .nullish(),
        
        
    
        timberKey: string()
        .trim()
        .nullish(),
        
        
    
            
            lengthFrom: coerce.number()
            .nullish(),
            lengthTo: coerce.number()
            .nullish(),
            
        
        
    
            
            diameterFrom: coerce.number()
            .nullish(),
            diameterTo: coerce.number()
            .nullish(),
            
        
        
    
            
            volumeFrom: coerce.number()
            .nullish(),
            volumeTo: coerce.number()
            .nullish(),
            
        
        
    
        timberTypeId: array(string()
            .nullish()),
        
        
    
        classId: array(string()
            .nullish()),
        
        
    
        thicknessClassId: array(string()
            .nullish()),
        
        
    
        shipmentId: string()
            .nullish(),
        
        
        shipmentIdInclude: boolean().default(false),
        
    
            localCreatedAtFrom: date().nullish(),
            localCreatedAtTo: date().nullish(),
            
        
        
        localCreatedAtInclude: boolean().default(false),
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;



type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const LogListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('Log')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const { data: timberTypeList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberTypeListLoading,
        isFetching: getTimberTypeListFetching, 
    } = useGetTimberTypeListQuery()
    
    
    const { data: timberClassList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getTimberClassListLoading,
        isFetching: getTimberClassListFetching, 
    } = useGetTimberClassListQuery()
    
    
    const { data: thicknessClassList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getThicknessClassListLoading,
        isFetching: getThicknessClassListFetching, 
    } = useGetThicknessClassListQuery()
    
    
    const [, setShipmentInputValue, shipmentInputTerm] = useSearchDebounce();
    const { data: shipmentList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getShipmentListLoading,
        isFetching: getShipmentListFetching, 
    } = useGetShipmentPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            key: shipmentInputTerm || '',
                    keyOr: true,
                    reportKey: shipmentInputTerm || '',
                    reportKeyOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const shipmentIdInclude = watch(prefix + 'shipmentIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="Log-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Timber Key, External Key, IK)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="Log-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'internalKey' }
                    label={t`IK`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'timberKey' }
                    label={t`Timber Key`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <Stack direction="row" spacing={1}>
                <crudgen.FormInput
                        name={ prefix + 'lengthFrom' }
                        label={t`Length (cm) From`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
                <crudgen.FormInput
                        name={ prefix + 'lengthTo' }
                        label={t`Length (cm) To`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
            </Stack>
            
        
    

                        
        
            
            <Stack direction="row" spacing={1}>
                <crudgen.FormInput
                        name={ prefix + 'diameterFrom' }
                        label={t`Diameter (cm) From`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
                <crudgen.FormInput
                        name={ prefix + 'diameterTo' }
                        label={t`Diameter (cm) To`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
            </Stack>
            
        
    

                        
        
            
            <Stack direction="row" spacing={1}>
                <crudgen.FormInput
                        name={ prefix + 'volumeFrom' }
                        label={t`Volume (m&#xB3;) From`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
                <crudgen.FormInput
                        name={ prefix + 'volumeTo' }
                        label={t`Volume (m&#xB3;) To`}
                        clearable={true}
                        
                        type='number'
                        checkNumber={true}
                        forceNumber={true}
                        
                />
            </Stack>
            
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'timberTypeId' }
                optionsLoading={ getTimberTypeListLoading || getTimberTypeListFetching }
                label={t`Timber Type`}
                options={ timberTypeList.items }
                valueMap={ (id) => useGetTimberTypeQuery(PrimaryTimberType.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberType }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberTypeNameDisplay data={option}/></li>)
                } }
                
                
                renderTags={(value: readonly string[], getTagProps) =>
                    value.map((option: any, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index })
                        return (
                            <crudgen.SelectChip key={key} {...tagProps}>
                                <TimberTypeName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
        />
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'classId' }
                optionsLoading={ getTimberClassListLoading || getTimberClassListFetching }
                label={t`Timber Class`}
                options={ timberClassList.items }
                valueMap={ (id) => useGetTimberClassQuery(PrimaryTimberClass.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringTimberClass }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><TimberClassNameDisplay data={option}/></li>)
                } }
                
                
                renderTags={(value: readonly string[], getTagProps) =>
                    value.map((option: any, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index })
                        return (
                            <crudgen.SelectChip key={key} {...tagProps}>
                                <TimberClassName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
        />
        
    

                        
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'thicknessClassId' }
                optionsLoading={ getThicknessClassListLoading || getThicknessClassListFetching }
                label={t`Thickness Class`}
                options={ thicknessClassList.items }
                valueMap={ (id) => useGetThicknessClassQuery(PrimaryThicknessClass.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringThicknessClass }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><ThicknessClassNameDisplay data={option}/></li>)
                } }
                
                
                renderTags={(value: readonly string[], getTagProps) =>
                    value.map((option: any, index: number) => {
                        const { key, ...tagProps } = getTagProps({ index })
                        return (
                            <crudgen.SelectChip key={key} {...tagProps}>
                                <ThicknessClassName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
        />
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'shipmentId' }
                optionsLoading={ getShipmentListLoading || getShipmentListFetching }
                label={t`Shipment`}
                options={ shipmentList.items }
                valueMap={ (id) => useGetShipmentQuery(PrimaryShipment.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringShipment }
                onInputChange={ setShipmentInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><ShipmentNameDisplay data={option}/></li>)
                } }
                disabled={ !!shipmentIdInclude }
                
            
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'shipmentIdInclude' }
        icon={<AddCircleOutline />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
        
            
                
                <crudgen.FormDateRange
                    startName={ prefix + 'localCreatedAtFrom' }
                    endName={ prefix + 'localCreatedAtTo' }
                    startLabel={t`Local Created At From`}
                    endLabel={t`Local Created At To`}
                />
                
            
        
    

                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default LogListSearch;
